import _ from "lodash";
import getAllTiposIndicador from "entity/TipoIndicador/all";
import Report from "report";
import TableReportHelper from "report/helper";
import LaudoVisita from "..";

export default class LaudoVisitaReport extends Report {
    constructor(uid, visita) {
        super();
        this.uid = uid;
        this.visita = visita;
    }

    get title() {
        return "Visita Técnica";
    }

    get fileName() {
        if (this.visita) {
            const uid = _.get(this.visita.data, "uid", "");
            const id = _.get(this.visita.data, "sequencialIndex", "_");
            const nomeFazenda = _.get(this.visita.data, "fazenda.nomeFazenda").trim();

            return `Visita Técnica nº ${id} - ${nomeFazenda} - ${uid}`;
        } else {
            return this.title;
        }
    }

    async render() {
        if (!this.visita) {
            this.visita = await LaudoVisita.get(this.uid);
        }

        // console.log('relatorio da visita: ', this.visita.data)
        this.helper = new TableReportHelper(this.visita.data);

        // caso não houver apontamentos cadastrados, retorna o conteúdo sem o render de apontamentos
        return [
            await this.renderSummary() ? await this.renderSummary() : this.renderHeader(),
            await this.renderApontamentos(),
            await this.renderParecerImages(),
            await this.renderParecer(),

            // TODO: show map with all the indicators coletas
            await this.renderAllApontamentosLocation()
        ]

    }

    renderHeader() {
        const h = this.helper;

        const content = [
            h.panel(
                [
                    h.row(
                        h.title("DADOS", { fontSize: 12, colSpan: 4 }),
                        h.title("Status"),
                        h.textField("status"),
                        h.title("Nº", { alignment: "right" }),
                        h.textField("sequencialIndex")
                    ),

                    h.row(
                        h.title("Fazenda:"),
                        h.textField("fazenda.nomeFazenda"),
                        h.title("Cód:"),
                        h.textField("fazenda.codFazenda"),
                        h.title("Safra:"),
                        h.textField("safra.safra"),
                        h.title("Cultura:"),
                        h.textField("cultura.cultura")
                    ),

                    h.row(
                        h.title("Proprietário:"),
                        h.textField("cliente.nome", { colSpan: 5 }),
                        h.title("ID:"),
                        h.textField("cliente.sequencialIndex")
                    ),



                    h.row(
                        h.title("Responsável:"),
                        h.textField("responsavel", { colSpan: 5 }),
                        h.title("Data da visita:"),
                        h.dateField("data")
                    ),

                    // prettier-ignore
                    h.row(
                        h.title("Frente:"),
                        h.listFrentes(this.visita?.frentes, { colSpan: 5 }),
                        h.title(""),
                        h.empty()
                    ),
                ],
                { widths: [60, "*", 25, 49, 38, "*", 60, "*"], unbreakable: true }
            ),
        ];

        return content;
    }

    async renderSummary() {
        const h = this.helper;

        const content = [
            this.renderHeader(),

            h.panel([
                // prettier-ignore
                h.row(
                    h.title("RESUMO DO LAUDO", { fontSize: 8, alignment: "center" })
                ),
            ]),
        ];
        let temUm = false;
        for (const TipoClass of getAllTiposIndicador()) {
            if (!this.visita.cliente) {
                throw new Error("Visita sem cliente")
            }

            let cont = await TipoClass.renderReportSummary(this.visita);

            if (cont && cont.length) {
                temUm = true;
            }

            content.push(cont);
        }
        if (!temUm) {
            return null;
        }

        content.push(this.renderFooter());
        content.push(h.pageBreak());

        return content;
    }

    async renderParecer() {
        const h = this.helper;

        const content = [

            h.panelBreakRows([
                // prettier-ignore
                h.row(
                    h.title("Parecer Técnico", { fontSize: 12 }),
                ),
                h.row(
                    h.textField("parecer"),
                ),
            ]),
        ];

        content.push(this.renderFooter());
        // return h.unbreakable(content);
        return content;
    }
    async renderParecerImages() {
        if (_.isEmpty(this.visita.data.itensImagemPtecnico)) {
            return null;
        }
        const h = this.helper;

        const content = [
            h.panel([
                // prettier-ignore
                h.row(
                    h.title("Imagens do Parecer")
                ),
            ]),
        ];

        const imagesContent = [
            // prettier-ignore
            h.row(
                h.title("Foto"),
                h.title(""),
                h.title("Descrição"),
            ),
        ];

        for (const image of this.visita.data.itensImagemPtecnico) {
            const r = h.helper(image);

            imagesContent.push(
                // prettier-ignore
                h.row(
                    r.imageField("base64", { fit: [150, 150], }),
                    r.locationField("georeferencia"),
                    r.textField("descricao", "imagem"),
                )
            );
        }

        content.push(h.panel(imagesContent, { widths: [150, 40, "*"] }));

        // return h.unbreakable(content);
        return content;
    }

    async renderApontamentos() {

        for (const TipoClass of getAllTiposIndicador()) {
            await TipoClass.renderReport(this.visita)
        }

        const h = this.helper;

        const content = [
            // this.renderHeader(),

            h.panel([
                // prettier-ignore
                h.row(
                    h.title("Apontamentos", { fontSize: 10, alignment: 'center' })
                ),
            ]),
        ];

        for (const TipoClass of getAllTiposIndicador()) {
            let ind = await TipoClass.renderReport(this.visita)

            content.push(ind);
        }

        // console.log("content", content)
        return content;
    }

    async renderAllApontamentosLocation() {

        // estrutura do valor a ser enviado para o handler
        // deve ser um array com todas as coordenadas listadas separadas cada uma no seu objeto
        // o acesso das informações está dentro do handler
        /*
            [
                {
                    lat: "123456",
                    lng: "123456",
                },
                {
                    lat: "123456",
                    lng: "123456",
                },
            ]
        */


        for (const TipoClass of getAllTiposIndicador()) {
            await TipoClass.renderReport(this.visita)
        }

        const tiposIndicadores = getAllTiposIndicador();
        const apontamentos = this.visita.data.apontamentos || []
        const coordinatesArray = []


        Object.keys(apontamentos).forEach((tipoKey) => {
            const tipoIndicador = tiposIndicadores.find(({ field }) => field === tipoKey);

            if (tipoIndicador) {
                const indicadoresValidos = tipoIndicador.indicadores.map((indicador) => indicador.field);

                Object.keys(apontamentos[tipoKey]).forEach((indicadorKey) => {
                    if (indicadoresValidos.includes(indicadorKey)) {
                        const coletas = apontamentos[tipoKey][indicadorKey];

                        if (Array.isArray(coletas)) {
                            coletas.forEach((coleta, index) => {
                                if (typeof coleta === "object" && coleta !== null) {
                                    if (coleta.coletas && coleta.coletas.length > 0) {
                                        coleta.coletas.forEach((col) => {
                                            coordinatesArray.push(col.georeferencia)
                                        })
                                    }
                                    if (coleta.pontosColetas && coleta.pontosColetas.length > 0) {
                                        coleta.pontosColetas.forEach((ponto) => {
                                            coordinatesArray.push(ponto.georeferencia)
                                        })
                                    }
                                }
                            });
                        }
                    }
                });
            }
        })

        const h = this.helper;

        const content = [
            h.pageBreak(),
            h.panel([
                // prettier-ignore
                h.row(
                    h.title("Localização das coletas", { fontSize: 10, alignment: 'center' }),
                ),
                h.row(
                    await h.getLocationImageByGeolocationArray(coordinatesArray)
                )
            ]),
        ];

        // for (const TipoClass of getAllTiposIndicador()) {
        //     let ind = await TipoClass.renderReport(this.visita)

        //     content.push(ind);
        // }

        // console.log("content", content)
        return content;
    }

    renderFooter() {
        const h = this.helper;
        const date = h.formatDate(h.get("data"));

        const content = [
            h.space(),

            h.panel([
                h.row(
                    h.text("________________________________________", { alignment: "center", style: null }),
                    h.text(`Data de Emissão: ${date}`, { fontSize: 8, alignment: "right", bold: true, style: null })
                ),

                // prettier-ignore
                h.row(
                    h.textField("tecnico.nome", { fontSize: 8, alignment: "center", style: null }),
                    ""
                ),

                // prettier-ignore
                h.row(
                    h.text("Técnico - TCH", { fontSize: 8, alignment: "center", bold: true, style: null }),
                    ""
                ),
            ]),
        ];

        return h.unbreakable(content);
    }
}
